import * as history from 'prosemirror-history';
import * as commands from 'prosemirror-commands';
import * as schemaList from 'prosemirror-schema-list';
import { findestSchema, stopOnTypes } from "./FindestDefaultSchema";

function chainCommands(..._args: any[]) {
    for (var _len = arguments.length, commands = new Array(_len), _key = 0; _key < _len; _key++) {
        commands[_key] = arguments[_key];
    }

    return function (state: any, dispatch: any, view: any) {
        for (var i = 0; i < commands.length; i++) {
            if (commands[i](state, dispatch, view)) return true;
        }

        return false;
    };
}

const buildKeymap = () => {
    const keymap: {[key: string]: any} = {};

    // Use control/command Z to undo in the histroy
    keymap["Mod-z"] = history.undo;
    // Use control/command Y or shift + control/command Z
    keymap["Shift-Mod-z"] = history.redo;
    keymap["Mod-y"] = history.redo;
    // Use backspace or delete to remove selections
    keymap["Backspace"] = chainCommands(commands.deleteSelection,
        commands.joinBackward, commands.selectNodeBackward);
    keymap["Delete"] = chainCommands(commands.deleteSelection,
        commands.joinForward, commands.selectNodeForward);

    // Use control/command B to toggle the boldness of the current selection or the next text
    if(findestSchema.marks.strong) {
        const type = findestSchema.marks.strong;
        let cmd = chainCommands(stopOnTypes(
                 [findestSchema.marks.subscript, findestSchema.marks.superscript]
            ),
            commands.toggleMark(type)
        );
        keymap["Mod-b"] = cmd;
        keymap["Mod-B"] = cmd;
    }    

    // Use control/command I to toggle the italics of the current selection or the next text
    if(findestSchema.marks.em) {
        const type = findestSchema.marks.em;
        let cmd = chainCommands(
            stopOnTypes(
                [findestSchema.marks.subscript, findestSchema.marks.superscript]
            ),
            commands.toggleMark(type)
        );
        keymap["Mod-i"] = cmd;
        keymap["Mod-I"] = cmd;
    }

    // Use Shift/control/command + enter to create a hard break in the text
    if(findestSchema.nodes.hard_break) {
        let br = findestSchema.nodes.hard_break;
        let cmd = chainCommands(commands.exitCode, (state: any, dispatch: any) => {
            dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
            return true;
        });
        keymap["Mod-Enter"] = cmd;
        keymap["Shift-Enter"] = cmd;
    }

    if (findestSchema.nodes.list_item) {
        let type = findestSchema.nodes.list_item;
        keymap["Enter"] = chainCommands(commands.newlineInCode, commands.createParagraphNear,
            commands.liftEmptyBlock, schemaList.splitListItem(type), commands.splitBlock);
        keymap["Mod-["] = schemaList.liftListItem(type);
        keymap["Mod-]"] = schemaList.sinkListItem(type);
    }

    return keymap;
};

export const findestKeymap = buildKeymap();